import { Observable ,  BehaviorSubject } from 'rxjs'

import { distinctUntilChanged, debounceTime } from 'rxjs/operators'

import { Injectable,
         isDevMode,
         ElementRef } from '@angular/core'

// import { AppStatic } from '../_helpers/app-static'
import { BoundingRectangle } from '../_models/bounding-rectangle.model'
// import { Outlets } from '../_models/outlets.model'
import { ScrollContainer } from '../_models/scroll-container.model'
import { WindowDimensions } from '../_models/window-dimensions.model'


export interface WindowHorizontalOffsets {
  leftBar1Offset: number,
  leftBar2Offset: number,
  leftBar3Offset: number,
  leftBoundBar1Offset: number,
  leftBoundBar2Offset: number,
  close1Offset: number,
  close2Offset: number,
  close3Offset: number
}

@Injectable()
export class WindowService {


  horizontalOffsets: any
  isUpdating: string
  lastImageLoadedTimestamp: number = 0
  isDevMode = isDevMode()

  // debugging issues from rewriting (i.e. opening popup + immediately scrolling)
  private shouldUpdateWindowDimensionsSubject = new BehaviorSubject<boolean>(false)
  public shouldUpdateWindowDimensions = this.shouldUpdateWindowDimensionsSubject.asObservable().pipe(debounceTime(1000))
  public shouldUpdateWindowDimensionsLocal: boolean
  private persistShouldUpdateWindowDimensions = false

  private windowDimensionsSubject = new BehaviorSubject<WindowDimensions>(new WindowDimensions())
  // public windowDimensions = this.windowDimensionsSubject.asObservable().pipe(distinctUntilChanged())
  public windowDimensions = this.windowDimensionsSubject.asObservable().pipe(debounceTime(100), distinctUntilChanged())
  private windowDimensionsLocal: WindowDimensions = new WindowDimensions()
  private keyboardHeight: number = 0
  private windowInnerHeightDefault: number
  private visibleViewportValues: any
  private visibleDiff: any
  // windowDimensionsLocal: WindowDimensions = new WindowDimensions()

  scrollElementAdmin: ElementRef
  private scrollContainerAdminSubject = new BehaviorSubject<ScrollContainer>(null)
  public scrollContainerAdmin = this.scrollContainerAdminSubject.asObservable().pipe(distinctUntilChanged())
  private scrollContainerAdminLocal: ScrollContainer

  scrollElementWindow: ElementRef
  private scrollContainerWindowSubject = new BehaviorSubject<ScrollContainer>(null)
  public scrollContainerWindow = this.scrollContainerWindowSubject.asObservable().pipe(distinctUntilChanged())
  private scrollContainerWindowLocal: ScrollContainer

  scrollElementMapMarkerDetail: ElementRef
  private scrollContainerMapMarkerDetailSubject = new BehaviorSubject<ScrollContainer>(null)
  public scrollContainerMapMarkerDetail = this.scrollContainerMapMarkerDetailSubject.asObservable().pipe(distinctUntilChanged())
  private scrollContainerMapMarkerDetailLocal: ScrollContainer

  scrollElementHome: ElementRef
  private scrollContainerHomeSubject = new BehaviorSubject<ScrollContainer>(null)
  public scrollContainerHome = this.scrollContainerHomeSubject.asObservable().pipe(distinctUntilChanged())
  private scrollContainerHomeLocal: ScrollContainer

  scrollElementModal: ElementRef
  private scrollContainerModalSubject = new BehaviorSubject<ScrollContainer>(null)
  public scrollContainerModal = this.scrollContainerModalSubject.asObservable().pipe(distinctUntilChanged())
  private scrollContainerModalLocal: ScrollContainer

  scrollElementSidebar: ElementRef
  private scrollContainerSidebarSubject = new BehaviorSubject<ScrollContainer>(null)
  public scrollContainerSidebar = this.scrollContainerSidebarSubject.asObservable().pipe(distinctUntilChanged())
  private scrollContainerSidebarLocal: ScrollContainer

  private keyboardResponseSubject = new BehaviorSubject<string>(null)
  public keyboardResponse = this.keyboardResponseSubject.asObservable().pipe(distinctUntilChanged())

  private keyboardVisibleSubject = new BehaviorSubject<boolean>(false)
  public keyboardVisible = this.keyboardVisibleSubject.asObservable().pipe(distinctUntilChanged())
  private keyboardVisibleLocal: boolean


  constructor (
  ) {}

  updateHorizontalOffsets(data: WindowHorizontalOffsets): any {
    this.horizontalOffsets = data
    this.updateWindowDimensions({ delay: 200, note: 'uho' })
  }

  updateScrollContainers(delay: number = 0) {
    this.conditionalDelay(delay, this.updateScrollContainersNow)
  }

  updateScrollContainersNow(reset:boolean = false) {
    // this.ensureNotBottom()
    this.scrollContainerAdminLocal = this.getNextScrollContainer('admin', reset)
    this.scrollContainerAdminSubject.next(this.scrollContainerAdminLocal)

    this.scrollContainerWindowLocal = this.getNextScrollContainer('window', reset)
    this.scrollContainerWindowSubject.next(this.scrollContainerWindowLocal)

    this.scrollContainerMapMarkerDetailLocal = this.getNextScrollContainer('map-marker-details', reset)
    this.scrollContainerMapMarkerDetailSubject.next(this.scrollContainerMapMarkerDetailLocal)

    this.scrollContainerModalLocal = this.getNextScrollContainer('modal', reset)
    this.scrollContainerModalSubject.next(this.scrollContainerModalLocal)

    this.scrollContainerSidebarLocal = this.getNextScrollContainer('sidebar', reset)
    this.scrollContainerSidebarSubject.next(this.scrollContainerSidebarLocal)

  }


  updateWindowDimensions(params = {}) {
    // if (params['note']) console.log('uwd', params['note'])
    // console.log('uwd', delay)
    // let delay = params['delay']
    this.conditionalDelay(params['delay'], this.updateWindowDimensionsNow.bind(this, params))
  }

  updateWindowDimensionsNow(params={}) {
    let force = params['force']
    let updatedViewport = this.updateVisualViewport() // note: update VP before getNextWindowDimensions
    let dims = this.getNextWindowDimensions()
    let simWindowDimensions = dims.isSimilarTo(this.windowDimensionsLocal)
    // let vv = window['visualViewport']
    // let simViewports = AppStatic.objectsAreSimilar(vv, this.visibleViewportValues)
    // if (!simViewports, window['visualViewport'], )
    // let updatedViewport = this.updateVisualViewport()

    // TODO: removed for infinite-list hacky fix... reimplement?
    // if (!force && simWindowDimensions && !updatedViewport) return // console.log('sim', dims)

    // console.log('!sim', dims)
    // TODO: more robust - what if keyboard is always open? ... maybe check if viewport.height === windowDimensions.innerHeight
    if (!this.windowInnerHeightDefault) this.windowInnerHeightDefault = dims.innerHeight
    // console.log('!SIM', dims, Object.assign({}, vv), window['visualViewport'])
    this.windowDimensionsLocal = dims
    this.windowDimensionsSubject.next(this.windowDimensionsLocal)
    this.updateScrollContainersNow(true)
  }

  viewportKeys() {
    return ['height', 'offsetLeft', 'offsetTop',
            'pageLeft', 'pageTop', 'scale', 'width']
  }
  viewportsAreSimilar(vp1, vp2) {
    if (!vp1 && !vp2) return true
    if (!vp1 || !vp2) return false
    let vpKeys = this.viewportKeys()
    for (let key of vpKeys) {
      if (vp1[key] !== vp2[key]) return false
    }
    return true
  }
  viewportFromParams(vpIn: any) {
    let vpOut = {}
    if (!vpIn) return vpOut
    for (let key of this.viewportKeys()) {
      vpOut[key] = vpIn[key]
    }
    return vpOut
  }


  updateVisualViewport(): boolean {
    let wvv = window['visualViewport']
    let sim = this.viewportsAreSimilar(this.visibleViewportValues, wvv)
    if (sim) return false
    this.visibleViewportValues = this.viewportFromParams(window['visualViewport'])// Object.assign({}, wvv)

    // console.log('vp', Date.now(), wvv, this.visibleViewportValues)
    return true // this.detectChanges()
  }

  updateShouldUpdateWindowDimensions(should: boolean, params = {}): any {
    let force = params['force'] || false // needed when 'should' is false
    let persist = params['persist'] // time to persist (ms)
    if (!force && this.shouldUpdateWindowDimensionsLocal) return // skips if set true since last update
    let shouldReally = this.persistShouldUpdateWindowDimensions || should
    this.shouldUpdateWindowDimensionsLocal = shouldReally
    this.shouldUpdateWindowDimensionsSubject.next(shouldReally)

    if (!persist) return
    this.setPersistSUWD(true)
    setTimeout(this.setPersistSUWD.bind(this, false), persist)
  }

  setPersistSUWD(persist: boolean) {
    this.persistShouldUpdateWindowDimensions = persist
  }

  pingWindowDimensions(params={}) {
    // let force = params['force']
    // let prevWD = this.windowDimensionsLocal
    let nextWD = this.getNextWindowDimensions()
    // console.log('pingWD', nextWD)
    // let eq = JSON.stringify(prevWD) === JSON.stringify(nextWD)
    // let eq = nextWD.isSimilarTo(this.windowDimensionsLocal)
    if (nextWD.isSimilarTo(this.windowDimensionsLocal)) return
    // console.log('pingWD', nextWD)
    this.updateWindowDimensionsNow()
  }

  updateScrollElement(scrollContainerType: string, el: any): Promise<any> {
    // console.log('updateScrollElement', scrollContainerType, el)
    switch (scrollContainerType) {
      case 'admin':
        this.scrollElementAdmin = el
        break
      case 'home':
        this.scrollElementHome = el
        break
      case 'window':
        this.scrollElementWindow = el
        break
      case 'map-marker-details':
        this.scrollElementMapMarkerDetail = el
        break
      case 'sidebar':
        this.scrollElementSidebar = el
        break
      case 'modal':
        this.scrollElementModal = el
        break
      default:
        console.log('ERROR scrollContainerType', scrollContainerType)
    }
    return Promise.resolve(el)
  }


  scrollReferencesFromType(scrollContainerType: string): [ElementRef, ScrollContainer] {
    switch (scrollContainerType) {
      case 'admin':
        return [this.scrollElementAdmin, this.scrollContainerAdminLocal]
      case 'home':
        return [this.scrollElementHome, this.scrollContainerHomeLocal]
      case 'map-marker-details':
        return [this.scrollElementMapMarkerDetail, this.scrollContainerMapMarkerDetailLocal]
      case 'modal':
        return [this.scrollElementModal, this.scrollContainerModalLocal]
      case 'sidebar':
        return [this.scrollElementSidebar, this.scrollContainerSidebarLocal]
      case 'window':
      default:
        return [this.scrollElementWindow, this.scrollContainerWindowLocal]
    }
  }

  updateKeyboardVisible(visible: boolean) {
    if (visible === this.keyboardVisibleLocal) return
    this.keyboardVisibleSubject.next(visible)
    this.keyboardVisibleLocal = visible
  }

  getVisibleViewport(attr: string): any {
    if (!attr) return console.log('ERR: getVisibleViewport attr', attr)
    let vp = this.windowDimensionsLocal.visualViewport
    let vpHeight
    if (vp && this.windowInnerHeightDefault) {
      // let vhTotal = vp.height + vp.offsetTop
      let visibleDiff = this.windowInnerHeightDefault - vp.height - vp.offsetTop
      // topDrag: the amount the edge top bar was dragged out of view (i.e. selecting bottom of textarea)
      // let topDrag = this.windowInnerHeightDefault - this.windowDimensionsLocal.innerHeight
      let heightDiff = this.windowDimensionsLocal.innerHeight - vp.height
      let wdHeightDiff = this.windowInnerHeightDefault - this.windowDimensionsLocal.innerHeight
      vpHeight = vp.height + visibleDiff // vp.offsetTop
      if (this.visibleDiff !== visibleDiff) {
        // console.log('diff', visibleDiff + wdHeightDiff, this.windowInnerHeightDefault - vp.height, visibleDiff, heightDiff, wdHeightDiff)
        // if (vp.offsetTop === 0) console.log('KEYBOARD', visibleDiff, vp.height, this.windowDimensionsLocal.innerHeight)
        this.visibleDiff = visibleDiff
        let keyboardHeightBestGuess = visibleDiff + wdHeightDiff
        if (this.keyboardHeight < keyboardHeightBestGuess) {
          console.log('KEYBOARD', keyboardHeightBestGuess, this.windowInnerHeightDefault - vp.height)
          this.keyboardHeight = keyboardHeightBestGuess
        }
        // console.log('ih vs vh', visibleDiff, vp.offsetTop, this.windowInnerHeightDefault, this.windowDimensionsLocal)
      }
    }
    // console.log('visibleHeight', visibleHeight)

    switch (attr) {
      case 'height': return vp ? vpHeight : this.windowDimensionsLocal.innerHeight
      case 'width': return vp ? vp.width : this.windowDimensionsLocal.innerWidth
      default: return vp // console.warn('ERR: attr?', attr)
    }
  }

  updateBoundingRectFromScroll(br: BoundingRectangle, scroll: ScrollContainer): Promise<BoundingRectangle> {
    if (!br) {
      console.log('updateBoundingRectFromScroll - br?')
      return Promise.resolve(null)
    }

    let brNew = new BoundingRectangle(br)

    let bottom = 0
    let top = 0
    let left = 0
    let right = 0

    if (scroll.scrollYDiff) {
      bottom = -scroll.scrollYDiff
      top = -scroll.scrollYDiff
      left =  -scroll.scrollXDiff
      right =  -scroll.scrollXDiff
    }

    if (br.bottomMeasured) {
      bottom = bottom + br.bottomMeasured
      top = top + br.topMeasured
      left = left + br.leftMeasured
      right = right + br.rightMeasured
    }

    brNew.bottom = bottom
    brNew.top = top
    brNew.left = left
    brNew.right = right

    // console.log('upBoundRectFromScroll', brNew.top, br, scroll)
    return Promise.resolve(brNew)
  }

  findBoundingRectangle( br: BoundingRectangle,
                         nativeElement: any,
                         params = {}) {
    let scrollContainerType = params['scrollContainerType'] || 'window'
    let force = params['force'] || false
    // if (force) { console.log('forced fBR', scrollContainerType, force) }

    if (!force && br && br.hasOwnProperty('topMeasured')) return Promise.resolve(br)
    if (!nativeElement) { console.log('no nativeElement'); return Promise.resolve(null) }
    return this.getBoundingRectangleOf(nativeElement, scrollContainerType).then( data => {
      let brOut = new BoundingRectangle(data)
      return brOut
    })
  }

  // , scroll: ScrollContainer
  getBoundingRectangleOf(nativeElement: any, scrollContainerType = 'window'): Promise<BoundingRectangle> {
    if (!nativeElement) return Promise.resolve(null)

    let parentRect = nativeElement.getBoundingClientRect()

    if (this.boundingClientRectIsZero(parentRect)) {
      // console.log('parentRect not visible / zero', parentRect)
      return Promise.resolve( null )
    }

    let scrollRefs = this.scrollReferencesFromType(scrollContainerType)
    let scrollContainer = scrollRefs[1]

    if (!scrollContainer) {
      console.log('no scrollContainer', scrollContainerType)
      Promise.resolve( null )
    }

    let topMeasured = parentRect.top
    if (scroll) { topMeasured = topMeasured + scrollContainer.scrollY }

    let height = parentRect.height

    // if (scrollContainerType === 'window') console.log('win-ht', this.windowDimensionsLocal)

    let br = new BoundingRectangle({
      height: parentRect.height,
      width: parentRect.width,
      x: parentRect.x,
      y: parentRect.y,

      bottom: parentRect.bottom,
      left: parentRect.left,
      right: parentRect.right,
      top: parentRect.top,

      bottomMeasured: parentRect.bottom,
      leftMeasured: parentRect.left,
      rightMeasured: parentRect.right,
      topMeasured: parentRect.top,
    })

    // console.log('getBoundingRect', br, parentRect, scrollContainer, scrollContainerType)
    return Promise.resolve( br )
  }

  snapTo(scrollContainerType: string, scrollTop: number, delay?: number): Promise<any> {
    // console.log('snapTo?', scrollContainerType, scrollTop, Object.assign({},this.scrollElementWindow.nativeElement))
    if (delay) {
      return new Promise((resolve) => setTimeout(resolve, delay)).then(res => {
        return this.snapTo(scrollContainerType, scrollTop)
      });
      // return setTimeout(this.snapTo.bind(this, scrollContainerType, scrollTop), delay)
    }
    // note: scrollTop is offsetTop of native element...
    switch (scrollContainerType) {
      case 'map-marker-details':
        let scrollTopDiff = this.windowDimensionsLocal.innerHeight > 600 ? 200 : 100
        this.scrollElementMapMarkerDetail.nativeElement.scrollTop = scrollTop - scrollTopDiff
        break
      case 'modal':
        this.scrollElementModal.nativeElement.scrollTop = scrollTop - 20
        break
      case 'sidebar':
        this.scrollElementSidebar.nativeElement.scrollTop = scrollTop
        break
      case 'admin':
      case 'window':
      default:
        if (!this.scrollElementWindow) return // Promise.reject() // console.log('snapTo: no ScrollElementWindow?')
        this.scrollElementWindow.nativeElement.scrollTop = scrollTop // - 70
        let currentScrollTop = this.scrollElementWindow.nativeElement.scrollTop
        // console.log('OH SNAP', scrollTop, currentScrollTop, this.scrollElementWindow.nativeElement.scrollTop)
        return new Promise((resolve) => setTimeout(resolve, 10)).then(() => {
          // console.log('OH SNAP', scrollTop, currentScrollTop, this.scrollElementWindow.nativeElement.scrollTop)
          return currentScrollTop
        });
        // break
    }
    // this.scrollElementWindow.nativeElement.scrollTop = scrollTop
    this.updateWindowDimensions({ delay: 100, note: 'snapTo' })
    // this.updateScrollContainers(100)
  }

  getContainerOffset(scrollContainerType: string) {
    let serverBarHeight = this.isDevMode ? 20 : 0
    switch (scrollContainerType) {
      case 'admin':
        return { top: 45 + serverBarHeight, right: 0, bottom: 0, left: 150 }
      case 'map-marker-details':
        if (this.windowDimensionsLocal.innerHeight > 600) {
          return { top: 225, right: 20, bottom: 20, left: 20 }
        } else {
          return { top: 175, right: 20, bottom: 20, left: 20 }
        }
      case 'modal':
        return { top: 0, right: 0, bottom: 0, left: 0 }
      default:
        return { top: 45 + serverBarHeight, right: 0, bottom: 0, left: 0 } // keep UTD with $headerHeight
    }
  }

  scrollContainer(scrollContainerType:string) {
    if (!scrollContainerType) return

    switch (scrollContainerType) {
      case 'admin':
        return this.scrollContainerAdmin
      case 'map-marker-details':
        return this.scrollContainerMapMarkerDetail
      case 'modal':
        return this.scrollContainerModal
      case 'window':
      default:
        return this.scrollContainerWindow
    }
  }

  checkGlobalVariables() {
    this.updateWindowDimensions({ delay: 500, note: 'cgv' })
    // this.updateScrollContainers(500)
  }


  conditionalDelay(delay: number, fxn: any) {
    if (delay === 0) return fxn.bind(this).apply()
    setTimeout(fxn.bind(this), delay)
  }

  getNextScrollContainer(scrollContainerType = 'window', reset = false): ScrollContainer {
    let refs:[ElementRef, ScrollContainer] = this.scrollReferencesFromType(scrollContainerType)
    let scrollElem = refs[0]
    let currentScrollContainer = refs[1] || {}
    let scrollX = 0
    let scrollY = scrollElem ? scrollElem.nativeElement.scrollTop : 0
    let scrollXDiff = 0
    let scrollYDiff = 0
    let scrollXMeasured = currentScrollContainer['scrollXMeasured']
    let scrollYMeasured = currentScrollContainer['scrollYMeasured']

    // if (scrollContainerType == 'admin') {
    //   console.log('getNext', refs, reset, scrollYMeasured)
    // }

    if (reset || !scrollYMeasured) {
      // set measured, reset diff
      scrollXMeasured = scrollX
      scrollYMeasured = scrollY
    } else {
      // update diff relative to measured
      scrollXDiff = scrollX - scrollXMeasured
      scrollYDiff = scrollY - scrollYMeasured
    }

    let scrollContainer = new ScrollContainer({
      scrollX: scrollX,
      scrollY: scrollY,
      scrollXMeasured: scrollXMeasured,
      scrollYMeasured: scrollYMeasured,
      scrollXDiff: scrollXDiff,
      scrollYDiff: scrollYDiff
    })

    return scrollContainer
  }

  getNextWindowDimensions(): WindowDimensions {
    let nextWindowDimensions = new WindowDimensions()
    // let vv = (window['visualViewport'] || {}).height
    // console.log('IH vs VV', window.innerHeight, vv)
    nextWindowDimensions.visualViewport = Object.assign({}, this.visibleViewportValues)
    nextWindowDimensions.innerHeight =  window.innerHeight
    nextWindowDimensions.innerWidth = window.innerWidth

    for (let propName in this.horizontalOffsets) {
      if (!propName) continue
      nextWindowDimensions[propName] = this.horizontalOffsets[propName]
    }
    // console.log('NWD', nextWindowDimensions)
    return nextWindowDimensions
  }

  // TODO - update with IsVisibleInParent (rather than just window)
  boundingClientRectIsInViewport(boundingClientRect) {
    let vvHeight = (this.windowDimensionsLocal.visualViewport || {}).height
    let vvWidth = (this.windowDimensionsLocal.visualViewport || {}).width
    let de = document.documentElement
    return (
        boundingClientRect.top >= 0 &&
        boundingClientRect.left >= 0 &&
        boundingClientRect.bottom <= (vvHeight || window.innerHeight || de.clientHeight) &&
        boundingClientRect.right <= (vvWidth || window.innerWidth || de.clientWidth)
    )
  }

  boundingClientRectIsZero(boundingClientRect) {
    let isZero = ( boundingClientRect.top === 0    && boundingClientRect.left === 0 &&
                   boundingClientRect.bottom === 0 && boundingClientRect.right === 0 )
    return isZero
  }
}
